import { Box, Button, Flex, Text, Image } from "@chakra-ui/react";
import bannerFilesLeft from "assets/img/dashboards/banner-files-left.svg";
import bannerFilesRight from "assets/img/dashboards/banner-files-rigth.svg";

interface CallToActionBannerProps {
  onPlaceOrder: () => void;
}

export const CallToActionBanner: React.FC<CallToActionBannerProps> = ({
  onPlaceOrder,
}) => {
  return (
    <Box
      bg="#E0E9FF"
      borderRadius="12px"
      position="relative"
      overflow="hidden"
      height="144px"
      px={{ base: "20px", md: "32px" }}
      mb="24px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      border="1px solid #5F94FF"
    >
      {/* Left SVG */}
      <Box
        position="absolute"
        left="0"
        top="50%"
        transform="translateY(-50%)"
        display={{ base: "none", md: "block" }}
      >
        <Image src={bannerFilesLeft} alt="" height="120px" width="auto" />
      </Box>

      {/* Right SVG */}
      <Box
        position="absolute"
        right="0"
        top="50%"
        transform="translateY(-50%)"
        display={{ base: "none", md: "block" }}
      >
        <Image src={bannerFilesRight} alt="" height="120px" width="auto" />
      </Box>

      {/* Center Content */}
      <Flex
        direction="column"
        alignItems="center"
        gap="16px"
        position="relative"
        zIndex="1"
      >
        <Text
          fontFamily="General Sans, sans-serif"
          fontWeight="600"
          fontSize={{ base: "20px", md: "24px" }}
          lineHeight="130%"
          textAlign="center"
          color="#1F2937"
        >
          Ready to start your next translation?
        </Text>
        <Button
          type="button"
          fontSize="16px"
          bgColor="#3A7BFF"
          fontWeight="600"
          h="48px"
          color="#FFFFFF"
          borderRadius="25px"
          border="1px solid #2C63E5"
          width="173px"
          onClick={onPlaceOrder}
          _hover={{
            bgColor: "#FFFFFF",
            color: "#2C63E5",
          }}
          _loading={{ pointerEvents: "none" }}
          _active={{
            bgColor: "#FFFFFF",
            color: "#2C63E5",
          }}
        >
          Place your order
        </Button>
      </Flex>
    </Box>
  );
};

export default CallToActionBanner;
